import * as fromDatatype from '../../../../../models/datatype-library';

export class PmtStmtEinvoiceLinkDto {
    guid: fromDatatype.GuidDataFieldInterface;
    date_txn: fromDatatype.TimestampTzDatatypeInterface;
    unique_id_no: fromDatatype.VarcharDatatypeInterface;
    supplier_name: fromDatatype.VarcharDatatypeInterface;
    doc_reference_no: fromDatatype.VarcharDatatypeInterface;
    delivery_order_no: fromDatatype.VarcharDatatypeInterface;
    purchase_order_no: fromDatatype.VarcharDatatypeInterface;
    validation_datetime: fromDatatype.TimestampTzDatatypeInterface;
    amount_txn: fromDatatype.NumericDatatypeInterface;
  }